export default {
  termsOfUse: "Conditions d'Utilisation",
  privacyPolicy: 'Politique de Confidentialité',
  cookiesPolicy: 'Politique de Cookies',
  careers: 'Carrières',

  connectSocialMedia: 'Pouvons-nous résoudre le problème le plus rapidement possible ?',
  copyright: 'Copyright',
  mtgAllRightsReserved: 'Cactus Communications. All rights reserved',
};
